import { matchRoutes, useLocation } from "react-router-dom";
import { appRoutes } from "routes";

export const useRouter = (): {
  matchTemplatePath: (templatePath: string) => boolean;
} => {
  const location = useLocation();

  const matchTemplatePath = (templatePath: string): boolean => {
    const matches = matchRoutes(appRoutes, location);
    return matches?.some((match) => match.route?.path?.includes(templatePath)) || false;
  };

  return {
    matchTemplatePath: (templatePath: string) => matchTemplatePath(templatePath),
  };
};
